/*
 * Modal helpers — open/close, plus data-close button wiring.
 */

export function $(id: string): HTMLElement {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element #${id}`);
  return el;
}

export function openModal(id: string): void {
  $(id).classList.add('active');
}

export function closeModal(id: string): void {
  $(id).classList.remove('active');
}

/** Wires every [data-close="<modal-id>"] element to close that modal on click. */
export function wireCloseButtons(): void {
  document.querySelectorAll<HTMLElement>('[data-close]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset['close'];
      if (target) closeModal(target);
    });
  });
}
